import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AtlasToastService } from '@services/atlas-toast.service';
import { LoaderService } from '@services/loader.service';
import { PaymentService } from '@services/payment.service';
import { loadStripe } from '@stripe/stripe-js';
import $ from 'jquery';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wsb-billing-payment-method',
  templateUrl: './billing-payment-method.component.html',
  styleUrls: ['./billing-payment-method.component.scss'],
  standalone: false
})
export class BillingPaymentMethodComponent implements OnInit {
  @ViewChild('modalDeletePaymentMethod') modalDeletePaymentMethod;
  @ViewChild('modalAddPaymentMethod') modalAddPaymentMethod;
  modalAddPaymentMethodModal: NgbModalRef;
  modalDeletePaymentMethodModal: NgbModalRef;

  paymentMethod;
  stripeKey;
  stripe;
  cardElement;
  dataLoaded = false;
  constructor(
    private paymentService: PaymentService,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private atlasToastService: AtlasToastService
  ) {}

  ngOnInit(): void {
    this.loaderService.show();
    this.loadPaymentMethod();
    this.initPaymentTab();
  }

  openModalDeletePaymentMethod(): void {
    this.modalDeletePaymentMethodModal = this.modalService.open(this.modalDeletePaymentMethod);
    this.modalDeletePaymentMethodModal.result.then(
      result => {},
      reason => {}
    );
  }

  loadPaymentMethod(): void {
    this.paymentService
      .getPaymentMethod()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(
        data => {
          this.dataLoaded = true;
          this.paymentMethod = data;
        },
        () => {
          this.dataLoaded = true;
          this.paymentMethod = null;
        }
      );
  }

  initPaymentTab() {
    // https://stripe.com/docs/payments/save-and-reuse
    this.loadPaymentMethod();

    this.paymentService.getStripeKey().subscribe(key => {
      this.stripeKey = key;
    });
  }

  modalDeletePaymentMethodForm(): void {
    this.paymentService.deletePaymentMethod().subscribe(
      () => {
        this.atlasToastService.success('common_success', null);
        this.loadPaymentMethod();
      },
      () => {
        this.atlasToastService.error('common_error', null);
        this.loadPaymentMethod();
      },
      () => {}
    );
    this.modalDeletePaymentMethodModal.close();
  }

  openModalAddPaymentMethod(): void {
    this.modalAddPaymentMethodModal = this.modalService.open(this.modalAddPaymentMethod);
    loadStripe(this.stripeKey).then(stripe => {
      this.stripe = stripe;
      const elements = this.stripe.elements();
      this.cardElement = elements.create('card');
      this.cardElement.mount('#card-element');
    });

    this.modalAddPaymentMethodModal.result.then(
      result => {},
      reason => {}
    );
  }

  modalAddPaymentMethodForm() {
    $('body > .modal').css('opacity', 0);
    this.paymentService.createSetupIntent().subscribe(d => {
      this.stripe
        .confirmCardSetup(d['setup-intent-client-secret'], {
          payment_method: {
            card: this.cardElement
          }
        })
        .then(result => {
          this.modalAddPaymentMethodModal.close();
          if (result.setupIntent) {
            if (result.setupIntent.status === 'succeeded') {
              const call = !this.paymentMethod
                ? this.paymentService.addPaymentMethod(result.setupIntent.payment_method)
                : this.paymentService.updatePaymentMethod(result.setupIntent.payment_method);
              call.subscribe(
                () => {
                  this.atlasToastService.success('common_success', null);
                  this.loadPaymentMethod();
                },
                () => {
                  this.atlasToastService.error('common_error', null);
                  this.loadPaymentMethod();
                }
              );
            } else {
              this.atlasToastService.error('common_error', null);
              this.loadPaymentMethod();
            }
          } else {
            if (result.error && result.error.message) {
              this.atlasToastService.error(result.error.message, null);
            } else {
              this.atlasToastService.error('common_error', null);
            }
            this.loadPaymentMethod();
          }
        });
    });
  }
}
